module.exports = __webpack_public_path__ + "img/BG040534040.f00c6539.svg";